import { withDependencies } from '@wix/thunderbolt-ioc'
import {
	CarmiInstance,
	DebugDataRequirementsCheckersSymbol,
	StateRefsStoreSymbol,
	ExportsStoreSymbol,
	IDataRequirementsCheckersDebugMap,
	IExportsStore,
	IStateRefsStore,
	IPropsStore,
	IStructureStore,
	Props,
	Structure,
} from '@wix/thunderbolt-symbols'
import type { DSCarmi, DSModelInput } from 'thunderbolt-ds-carmi-root'
import { ViewerAPIProviderInitializer, ViewerManagerApi } from 'thunderbolt-viewer-manager-types'
import { createTpaMessageHistoryApi, DevToolsSymbol, IDevtoolsConnector } from 'feature-debug'
import type { IDebugAPI, IDebugDS } from './types'
import { Catharsis, CatharsisSymbol } from '@wix/thunderbolt-catharsis'

const getCarmiData = (dsCarmi: DSCarmi) => {
	// @ts-ignore - $model is not defined in the DSCarmi type
	const $model: DSModelInput = dsCarmi.$model
	const { structure, data, renderFlags } = $model
	return {
		structure,
		data,
		renderFlags,
	}
}

export const DebugDs = withDependencies(
	[
		Props,
		ExportsStoreSymbol,
		StateRefsStoreSymbol,
		Structure,
		ViewerManagerApi,
		CarmiInstance,
		DebugDataRequirementsCheckersSymbol,
		DevToolsSymbol,
		CatharsisSymbol,
	],
	(
		props: IPropsStore,
		exports: IExportsStore,
		stateRefs: IStateRefsStore,
		structureStore: IStructureStore,
		viewerAPIProviderInitializer: ViewerAPIProviderInitializer,
		dsCarmi: DSCarmi,
		{ getDataRequirementsCheckersDebugMap }: IDataRequirementsCheckersDebugMap,
		reduxDevtoolsConnector: IDevtoolsConnector,
		catharsis: Catharsis
	): IDebugDS => {
		const { api: tpa, clearHistory, tpaMessageHistory } = createTpaMessageHistoryApi()
		const dataRequirementsCheckers = getDataRequirementsCheckersDebugMap()

		viewerAPIProviderInitializer().then((viewerApiProvider) => {
			const viewerAPI = viewerApiProvider.getViewerAPI()
			let currentGetCarmiData = getCarmiData
			const debugApi: IDebugAPI = {
				props,
				exports,
				stateRefs,
				structureApi: structureStore,
				dsCarmi,
				viewerAPI,
				tpa: {
					messages: tpaMessageHistory,
					clearHistory,
				},
				dataRequirementsCheckers,
				updateReduxCarmiData: (getValue) => {
					currentGetCarmiData = getValue ?? getCarmiData
				},
				catharsis,
			}

			reduxDevtoolsConnector.connect({
				getEntireStore: () => currentGetCarmiData(dsCarmi),
				subscribeToChanges: (callback) => {
					const cb = () => callback(undefined)
					dsCarmi.$addListener(cb)
					return () => dsCarmi.$removeListener(cb)
				},
			})

			if (!window.debugApi) {
				window.debugApi = debugApi
			} else {
				window.miniSiteDebugApi = debugApi
			}
		})

		return {
			tpa,
		}
	}
)
